import { ComponentStrategyFuncType, GetSceneParamsType,  MobileBusinessComponent, MobileBusinessComponentInfoMap, PlatformType } from './type';

import { sceneConfig as  mobileStrategy } from './strategys/mobileStrategy';
import { sceneConfig as pcStrategy } from './strategys/pcStrategy';

/**
 * @description 获取场景配置
 * @return {*}
 */
export function getSceneConfig(sceneParams: GetSceneParamsType): MobileBusinessComponentInfoMap {
  const config = {};

  let strategyMap;

  // 第一步，根据Pc和移动端来判断使用哪个策略Map

  if (sceneParams.platform === PlatformType.PC) {
    strategyMap = pcStrategy;
  } else {
    strategyMap = mobileStrategy;
  }

  // 命中到的场景配置
  const matchedSceneConfig = strategyMap[sceneParams.businessScene];

  (Object.keys(matchedSceneConfig) as MobileBusinessComponent[]).forEach((componentKey) => {
    const componentStrategy = matchedSceneConfig[componentKey];
    // 如果策略是一个函数
    if (typeof componentStrategy === 'function') {
      const result = (componentStrategy as ComponentStrategyFuncType<any, any>)(sceneParams);
      config[componentKey] = result;
    } else {
      config[componentKey] = componentStrategy;
    }
  });
  return config as MobileBusinessComponentInfoMap;
}
